import type WidgetFeaturesIds from '../../core/modules/features/types/WidgetFeaturesIds';
import type { Widget } from '../../core/types/Widget';
import { WidgetInitialiserOptions } from '../../core/types/WidgetInitialiserOptions';
import { WidgetType } from '../../core/types/WidgetType';

import sanitizeString from './sanitizeString';

export const getSkip = (
  props: Partial<WidgetFeaturesIds>,
  options: Partial<WidgetInitialiserOptions>,
  widget: Widget,
): boolean => {
  const { editorialOnPage, keywords, defaultParams } = options;

  const { skip, excludeFrom, hiddenDealWidget } = props;

  let skipWidget = Boolean(
    (skip || '').split(',').find((s) => {
      switch (s) {
        case 'disabled':
          // If skip is disabled, the widget should not be rendered regardless fo anything else
          // (i.e. van-hawk-none)
          return true;
        case 'editorial':
          // Only render if there are no editorial widgets unless they are type 'link' or 'inbody'
          return editorialOnPage;
        case 'dealsy':
          // Added for seasonal widget - skip if a substring match for any of the below tags
          // are found or the article type is deals
          return keywords?.find((k) => {
            const tags = ['amazonprimeday', 'blackfriday', 'sensitive'];

            return (
              tags.find((t) => sanitizeString(k).indexOf(t) >= 0) ||
              defaultParams?.articleType === 'deals'
            );
          });
        default:
          // Always render
          return false;
      }
    }),
  );

  if (
    (widget.type === WidgetType.DEAL || widget.type === WidgetType.ANF_DEAL) &&
    excludeFrom &&
    hiddenDealWidget
  ) {
    skipWidget = true;
  }

  return skipWidget;
};
